import { FaTrash } from "react-icons/fa";

interface ManageSpecsCardProps {
    name: string;
    product: "Leads" | "Calls" | "Traffic";
    type: "Direct Post" | "Ping Post" | "RTB" | "Availability Ping" | "N/A";
    onDelete: () => void;
}

export default function ManageSpecsCard({
    name,
    product,
    type,
    onDelete,
}: ManageSpecsCardProps) {
    return (
        <div className="flex flex-col md:flex-row md:items-center justify-between bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-lg p-4 mb-4 shadow-md transition-shadow hover:shadow-lg">
            <div className="flex flex-col md:flex-row md:items-center gap-4">
                <div className="px-3 py-1 rounded-lg bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200 text-sm font-medium">
                    {product}
                </div>

                <div className="px-3 py-1 rounded-lg bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-200 text-sm font-medium">
                    {type}
                </div>

                <div className="text-lg font-semibold text-gray-900 dark:text-white">
                    {name}
                </div>
            </div>

            <div className="flex gap-2 mt-2 md:mt-0">
                <button
                    onClick={onDelete}
                    className="flex items-center gap-1 px-3 py-1 rounded-lg bg-red-500 text-white hover:bg-red-600 transition-colors"
                >
                    <FaTrash /> Delete
                </button>
            </div>
        </div>
    );
}